import React, { useState, useEffect } from "react";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { StyledDataGrid } from "../../../../common/components/DataGrid/styles";
import { StyledButton } from "../../../../common/components/Button";
import AddSourceDialog from "./AddSourceDialog";
import { StyledH2 } from "../../../../common/components/Title/styles";
import UpdateSourceDialog from "./UpdateSourceDialog";
import { deleteSource, getAllSources } from "../../../../api/sourcesApi";
import ConfirmationDialog from "../../../../common/components/Dialog";
const SourcesTable = ({ theme, handleOpenAlert, handleSetAlertMessage }) => {
  const [openAddSource, setOpenAddSource] = useState(false);
  const [openUpdateSource, setOpenUpdatelignerMaterial] = useState(false);

  const [rows, setRows] = useState([]);
  const [currentSource, setCurrentSource] = useState({});
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [confirmationSubmit, setConfirmationSubmit] = useState(
    () => () => null
  );
  useEffect(() => {
    fetchSources();
  }, []);

  const fetchSources = async () => {
    const response = await getAllSources();

    setRows([...response]);
  };

  const handleOpenAddSource = () => {
    setOpenAddSource(true);
  };

  const handleCloseAddSource = () => {
    setOpenAddSource(false);
  };
  //Update
  const handleOpenUpdateSource = (event, params) => {
    event.stopPropagation();
    setCurrentSource({ ...params.row });
    setOpenUpdatelignerMaterial(true);
  };
  const handleCloseUpdateSource = () => {
    setOpenUpdatelignerMaterial(false);
  };

  const handleDeleteSource = async (id) => {
    await deleteSource({ Id: id });
    // if (response.data.error != null) {
    //   setErrorMessage(response.data.error.message);
    //   handleOpenSnackbar();
    // }
    await fetchSources();
  };

  const columns = [
    { field: "name", headerName: "Source", flex: 1 },
    {
      field: "col5",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => {
        console.log(params.row.name);
        return (
          <>
            <GridActionsCellItem
              icon={<FontAwesomeIcon icon={faPen} />}
              label="Update"
              onClick={(e) => handleOpenUpdateSource(e, params)}
            />
            {params.row.name === "Alina Portal" ||
            params.row.name === "Alina Website" ? null : (
              <GridActionsCellItem
                icon={<FontAwesomeIcon icon={faTrash} />}
                label="Delete"
                onClick={(e) => {
                  e.stopPropagation();
                  console.log(params);
                  setShowConfirmationDialog(true);
                  setConfirmationSubmit(() => () => {
                    handleDeleteSource(params.id);
                    setShowConfirmationDialog(false);
                  });
                }}
              />
            )}
          </>
        );
      },
    },
  ];

  return (
    <div>
      <StyledH2 theme="purple">Sources</StyledH2>
      <StyledButton onClick={handleOpenAddSource} theme="green">
        <FontAwesomeIcon icon={faPlus} style={{ paddingRight: "3px" }} />
        Add source
      </StyledButton>

      <AddSourceDialog
        openAddSource={openAddSource}
        handleCloseAddSource={handleCloseAddSource}
        currentSource={currentSource}
        fetchSources={fetchSources}
        handleOpenAlert={handleOpenAlert}
        handleSetAlertMessage={handleSetAlertMessage}
      />
      <UpdateSourceDialog
        openUpdateSource={openUpdateSource}
        handleCloseUpdateSource={handleCloseUpdateSource}
        currentSource={currentSource}
        fetchSources={fetchSources}
      />
      <ConfirmationDialog
        open={showConfirmationDialog}
        handleClose={() => setShowConfirmationDialog(false)}
        submit={confirmationSubmit}
        title={"Delete source?"}
      />
      <StyledDataGrid
        autoHeight
        rows={rows}
        columns={columns}
        pageSize={50}
        rowsPerPageOptions={[]}
      />
    </div>
  );
};

export default SourcesTable;
